import React, { useState, useEffect } from 'react';
import filterMovementImg from './image.png'; // Import the image

const CFSFeatureTour = ({ onClose }) => {
  const [highlightPosition, setHighlightPosition] = useState({ top: 0, left: 0, width: 0, height: 0 });
  const [showTooltip, setShowTooltip] = useState(false); // Start with false for step 2 behavior

  const step = {
    id: 'filter-icon',
    title: "We Moved 'All Filters' here!",
    description: 'Refine Search and Show Deals By have been combined to a single filter for easier access.',
    selector: 'button[aria-label="filter-button"]',
    position: 'bottom-left',
    badge: 'MOVED'
  };

  useEffect(() => {
    updateHighlightPosition();
    window.addEventListener('resize', updateHighlightPosition);
    
    // Animation: Show tooltip after 1 second (step 2 behavior)
    setShowTooltip(false); // Hide tooltip initially
    const timer = setTimeout(() => {
      setShowTooltip(true); // Show tooltip after 1 second
    }, 1000);
    
    // Add click listener for filter button
    const filterButton = document.querySelector('button[aria-label="filter-button"]');
    
    if (filterButton) {
      filterButton.addEventListener('click', handleClose);
    }
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateHighlightPosition);
      if (filterButton) {
        filterButton.removeEventListener('click', handleClose);
      }
    };
  }, []);

  const updateHighlightPosition = () => {
    const element = document.querySelector(step.selector);
    
    if (element) {
      const rect = element.getBoundingClientRect();
      setHighlightPosition({
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      });
    }
  };

  const handleSkip = () => {
    handleClose();
  };

  const handleClose = () => {
    onClose();
  };

  const getTooltipPosition = () => {
    const padding = 20;
    const tooltipWidth = 350; // Approximate width of tooltip
    
    let style = {
      position: 'fixed',
      zIndex: 10003, // Higher than overlay (10000) to appear on top
    };

    // Calculate if tooltip would go off-screen on the right
    const wouldOverflow = (highlightPosition.left + tooltipWidth) > window.innerWidth;
    
    if (wouldOverflow) {
      // Position from the right edge to prevent cutoff
      style.top = `${highlightPosition.top + highlightPosition.height + padding}px`;
      style.right = `${window.innerWidth - (highlightPosition.left + highlightPosition.width)}px`;
    } else {
      // Position normally from the left
      style.top = `${highlightPosition.top + highlightPosition.height + padding}px`;
      style.left = `${highlightPosition.left}px`;
    }

    return style;
  };

  return (
    <>
      {/* Overlay - Step 2: Show image in center WITH filter icon cutout */}
      <div 
        className="fixed inset-0 z-[10000]"
        onClick={handleSkip}
        style={{
          background: 'rgba(0, 0, 0, 0.6)',
          clipPath: `polygon(
            0% 0%, 
            0% 100%, 
            ${highlightPosition.left - 8}px 100%, 
            ${highlightPosition.left - 8}px ${highlightPosition.top - 8}px, 
            ${highlightPosition.left + highlightPosition.width + 8}px ${highlightPosition.top - 8}px, 
            ${highlightPosition.left + highlightPosition.width + 8}px ${highlightPosition.top + highlightPosition.height + 8}px, 
            ${highlightPosition.left - 8}px ${highlightPosition.top + highlightPosition.height + 8}px, 
            ${highlightPosition.left - 8}px 100%, 
            100% 100%, 
            100% 0%
          )`
        }}
      >
        {/* Center Image showing filter movement */}
        <div className="absolute top-[57%] left-[14%] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
          <div className="relative">
            {/* Number 1 Badge - Top Right of Image */}
            <div className="absolute -top-3 -right-3 z-10 bg-[#BC8B20] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
              1
            </div>
            <img 
              src={filterMovementImg} 
              alt="Filter moved from sidebar to icon" 
              className="max-w-4xl w-auto h-auto rounded-lg shadow-2xl"
              style={{ maxHeight: '80vh' }}
            />
          </div>
        </div>
      </div>

      {/* Tooltip */}
      {showTooltip && (
        <div 
          className="bg-white rounded-lg shadow-2xl p-4 max-w-sm relative animate-fadeIn"
          style={getTooltipPosition()}
        >
          {/* Number 2 Badge - Top Left of Tooltip */}
          <div className="absolute -top-3 -left-3 bg-[#BC8B20] text-white w-10 h-10 rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
            2
          </div>
        
          {/* Content */}
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              {step.title}
            </h3>
            
            <p className="text-gray-600 mb-3 leading-relaxed">
              {step.description}
            </p>

            {/* Button */}
            <div className="flex justify-end">
              <button
                onClick={handleClose}
                className="bg-[#BC8B20] hover:bg-[#a67a1c] text-white px-4 py-2 rounded-lg font-medium transition-colors"
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add CSS animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out forwards;
        }
      `}</style>
    </>
  );
};

export default CFSFeatureTour;
